import * as React from 'react';

import { Box, BoxProps } from '@mui/material';

import { Breadcrumbs } from '../../breadcrumbs/breadcrumbs';

export type MainContentProps = {
  children?: React.ReactNode;
  hideBreadcrumbs?: boolean;
} & BoxProps;

export const MainContent: React.FC<MainContentProps> = ({
  children,
  hideBreadcrumbs,
  ...props
}) => {
  return (
    <Box component="main" flexDirection="column" flexGrow={1} gap={3} minWidth={0} {...props}>
      {!hideBreadcrumbs && <Breadcrumbs />}
      {children}
    </Box>
  );
};
